import { CFormGroup } from "@coreui/react";
import "react-datepicker/dist/react-datepicker.css";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  BasicNumberInput,
  ConditionalInput,
  DemoWarning,
  ErrorText,
  FormStepWrapper,
  QuestionWrapper
} from "src/components";
import DatePicker from "src/components/DatePicker/DatePicker";
import { InfoTooltip } from "../components";
import OptionalQuestion from "../components/OptionalQuestion";

const EmployeeSurvey1 = ({ data: values = {}, onChange, info, isDemo }) => {

  const {
    formState: { errors },
  } = useFormContext();

  console.log("EmployeeSurvey1 render with values:", values);

  const { t } = useTranslation();
  const { optionalQuestions } = useFormContext();

  const numberOfQuestionsOnThisPage = (isDemo || optionalQuestions?.q1b) ? 3 : 2;


  const { startDate } = info;

  return (
    <FormStepWrapper
      aboveCardSlot={
        isDemo ? (
          <>
            <DemoWarning />
            <p className="text-danger w-75 mx-auto text-center">
              {t("employeeSurvey.surveyDemo")}
            </p>
          </>
        ) : null
      }
    >
      <h1 className="text-center">{info.orgName}</h1>
      <h2 className="mb-3 text-center">
        {t("employeeSurvey.title", "Employee carbon survey")}
      </h2>
      <p className="mb-5 text-center">
        {t(
          "employeeSurvey.intro",
          "Thank you for taking the time to complete this short survey about your commute, working from home and a few other areas which may create work related emissions. This is extremely valuable input to our assessment and emission reduction plan."
        )}
      </p>

      <QuestionWrapper>
        <ConditionalInput
          defaultValue={values["started-before-period"]}
          name="started-before-period"
          onChange={(e) => {
            onChange(e);
            if (e.target.value === true || e.target.value === "true") {
              onChange({ target: { name: "start-date", value: startDate } });
            } else {
              // onChange({ target: { name: "start-date", value: null } });
            }
          }}
          errors={errors}
          reverseLogic={true}
          questionSlot={
            <h3 className="mb-3">
              1a.{" "} Did you start working for {info.orgName} before{" "}
              {startDate ? new Date(startDate).toLocaleDateString() : ""}?
            </h3>
          }
          inputSlot={
            <>
              <p className="mb-3">
                {t(
                  "employeeSurvey.q_startWorkingMonthYear",
                  "Please provide the month and year you started:"
                )}
              </p>
              <DatePicker
                className="w-100 mb-4"
                isClearable
                name="start-date"
                value={values["start-date"]}
                onChange={onChange}
                dateFormat="MM/yyyy"
                showMonthYearPicker
              />
              <ErrorText value={errors["start-date"]} />
            </>
          }
        />
        {/* {(stillWorking === false || !!values["end-date"]) && ( */}
        <OptionalQuestion name="q1b">

          <h3 className="mb-3 ">
            1b.
            {t(
              "employeeSurvey.q_endWorking",
              " If you are not currently actively working at the organisation, please give the last day that you worked."
            )}
            <InfoTooltip
              content={t(
                "employeeSurvey.endWorkingHint",
                "You may be on leave of absence, parental leave or your contract has finished for example. Please skip this question if not relevant."
              )}
            />
          </h3>
          <CFormGroup className="mb-4">
            <DatePicker
              className="w-100"
              isClearable
              name="end-date"
              value={values["end-date"]}
              onChange={onChange}
            />
            <ErrorText value={errors["end-date"]} />
          </CFormGroup>
        </OptionalQuestion>
        {/* )} */}
        <ConditionalInput
          defaultValue={values["had-leave"]}
          name="had-leave"
          onChange={onChange}
          errors={errors}
          questionSlot={
            <h3 className="mb-3">
              1{numberOfQuestionsOnThisPage === 2 ? "b" : "c"}.{" "}
              {t(
                "employeeSurvey.q_leave",
                "Thinking about the whole of {{period}}, while you have been employed or contracted with the organisation, did you have any periods of leave other than annual leave (e.g. parental leave, leave of absence, sabatical)?",
                { period: info.reportingPeriod }
              )}
            </h3>
          }
          inputSlot={
            <>
              <p className="mb-3">
                {t(
                  "employeeSurvey.q_weeksLeave",
                  "How many weeks of leave did you have?"
                )}
              </p>
              <BasicNumberInput
                allowNegative={false}
                min={1}
                max={52}
                placeholder={t(
                  "employeeSurvey.q_weeksLeavePlaceholder",
                  "Enter number of weeks..."
                )}
                name="weeks-leave"
                defaultValue={values["weeks-leave"]}
                onChange={onChange}
              />
              <ErrorText value={errors["weeks-leave"]} />
            </>
          }
        />
      </QuestionWrapper>
    </FormStepWrapper>
  );
};

export default EmployeeSurvey1;
